export const PRICE_OVERLAY_DATA = Symbol.for('PRICE_OVERLAY_DATA');
export const PRICE_TYPE_RELATION = {
  'black friday special': 'Black Friday Deal',
  'cyber monday special': 'Cyber Monday Deal',
};
export const CLEARANCE_IDS = new Set([6, 7, 10, 16, 19]);

export default PRICE_OVERLAY_DATA;
